import React from 'react';
import ApiRequestLog from '../components/ApiRequestLog';

// ─── Onda 66: tela própria do Log de Requisições ────────────────────────────
//
// O log era a segunda aba de /api-integration e por isso só abria para
// superadministrador — a trava existe pela emissão de chave, não pela leitura
// do histórico. Quem escreve o integrador precisa ver que chamada chegou e com
// que código saiu; não precisa poder criar credencial nenhuma.
//
// A tela é a mesma tabela, montada a partir do componente compartilhado. O
// superadmin continua vendo o log dentro de /api-integration, ao lado das
// chaves; ninguém perdeu caminho.
export default function ApiRequestLogPage() {
  const token = localStorage.getItem('token');
  return (
    <div className="api-integration">
      <ApiRequestLog token={token} standalone />
    </div>
  );
}
